/**
 * useEffectで変更される一つ前の値が参照できる
 * 以下のように使用する
 *
 * const prevInputValues = usePreviousValue(inputValue);
 *
 * useEffect(() => {
 *   console.log(prevInputValues) => 変更前の値
 *   console.log(inputValue) => 変更された値
 * }, [inputValue]);
 */
import { useEffect, useRef } from 'react';

const usePreviousValue = (value) => {
  const previousValue = useRef(0);

  useEffect(() => {
    previousValue.current = value;
  }, [value]);

  return previousValue.current;
};

export default usePreviousValue;
